
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import ContractPageForDownloadPDF from '../contractPageForDownloadPDF';
import commonUtil from '../../../../utils/commonUtil';
import pdfUtil from '../../../../utils/PDFUtil';
import { constDownload, constPrint } from '../../../../utils/clientConstant'; // constAPIFailure, constAPISuccess,
import DownloadPDFWithoutPreview from '../../../../components/DownloadPDFWithoutPreview';

// import * as createEventObject from '../../../createEvent/actions';
// import { setPageFlag, loadContractPage } from '../ContractPage/actions';
// import { _fetchProfileEventsInfo } from '../../../Accounts/createAccount/actions';

const pageName = 'contract';
const applicationRoutes = commonUtil.getApplicationRoutes();

// @connect(store => ({
//   lables: store.labels.data,
//   error: store.labels.error,
//   loading: store.labels.loading,
//   extraData: store.labels.extraData,
//   contractPage: store.contractPage.data,
//   eventDetails: store.eventDetail.data,
//   globleObj: store.globleObject,
//   eventCategoryType: store.eventcategory.data,
//   createEventObject: store.createEventObject,
//   printingDate: store.info.data.time,
// }),
//   { ...createEventObject, _fetchProfileEventsInfo, setPageFlag, loadContractPage })

class DownloadContractForIphone extends Component {

  constructor(props) {
    super(props);
    this.userAllData = '';
    this.warningMessage = null;
    this.enableButton = true;
    this.containerEl = document.createElement('div');
    this.externalWindow = null;
  }
  componentWillUnmount() {
    // STEP 5: This will fire when this.state.showWindowPortal in the parent component becomes false
    // So we tidy up by closing the window
    // this.externalWindow.close();
  }
  componentDidMount() {
    // STEP 3: open a new browser window and store a reference to it
    this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=200');

    // STEP 4: append the container <div> (that has props.children appended to it) to the body of the new window
    this.externalWindow.document.body.appendChild(this.containerEl);
    this.props.onCompletion(false);
  }
  UNSAFE_componentWillMount() {
    // let eventType = '';
    // let eventDate = '';
    // let levelTwo = '';

    // if (this.props.createEventObject && this.props.createEventObject.SelectTypeCelebration && this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration && this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name) {
    //   eventType = this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
    // }
    // levelTwo = eventType + '_' + 2;
    // if (this.props.createEventObject && this.props.createEventObject[levelTwo].data) {
    //   eventDate = this.props.createEventObject[levelTwo].data.eventDate;
    // }
    // const { loadContractPage } = this.props; // eslint-disable-line no-shadow
    // loadContractPage(eventType, eventDate);
    // this.handlePDFDownload();
  }

  downloadToPDF = (param) => {
    const fileName = 'Contract';
    if (param && param === constDownload) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }]), '_blank', 'scrollbars=yes,width=' + screen.width + ',height=' + screen.height);
    } else if (param && param === constPrint) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }]), 'PRINT', '_blank', 'height=400,width=600');
    }
  }

  getContractData = () => {
    const contractPage = this.props.contractPage;
    const contractData = (contractPage && contractPage.contractDetailsInfo && contractPage.contractDetailsInfo.contractdata) ? contractPage.contractDetailsInfo.contractdata : '';
    return contractData;
  }
  handleiOs = (data) => {
    // Handle Data
    // const iFrame = document.createElement('iframe');
    // iFrame.src = data;
    // this.dataUrl = iFrame;
    // this.dataUrl.src = data;
    this.externalWindow.location = data;
    // this.externalWindow.location.replace(data);
  }

  handlePDFDownload = () => {
    const downloadableContent = (<DownloadPDFWithoutPreview printingDate={this.props.printingDate} download><ContractPageForDownloadPDF lables={this.props.lables} userAllData={this.userAllData} contractData={this.getContractData()} /></DownloadPDFWithoutPreview>);
    pdfUtil.attachToDomForiOS(downloadableContent, 'contract', this.handleiOs);
  }

  render() {
    // return (<div>Contract Download</div>);
    this.dataUrl = document.createElement('iframe');
    // this.containerEl = document.createElement('div');
    this.handlePDFDownload();
    return ReactDOM.createPortal(null, this.containerEl);
  }
}
export default DownloadContractForIphone;
